module.exports = __webpack_public_path__ + "0a64f7b1538d8fa8a233b4b2044c610b.png";